// extracted by css-extract-rspack-plugin
export default {"radar":"tdIZ5G0Mruwjtsbc","chart":"D_R4D1CRXYD6zldY","tooltip":"OalfkeZTm8Qd4n4Z","isShown":"Labf8rbz0wZVEbHr","labels":"T7o7EIn01VMuOruB"};